import React, { useEffect, useState } from "react";
import amaxText from "../../images/amaxText.png";
import amaxTextWhite from "../../images/amaxTextWhite.png";
import userman from "../../images/userman.png";
import { Link, useLocation } from "react-router-dom";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import API_URL from '../../api/API';


export const CoachUserHeader = () => {
  const { coach } = useCoachAuthContext();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const fetchUnreadMessageCount = async () => {
      try {
        const response = await fetch(`${API_URL.GET_COACH_UNREAD_MESSAGE_COUNT}${coach.id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${coach.token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setUnreadCount(data.count);
        } else {
          throw new Error('Failed to fetch unread count');
        }
      } catch (error) {
        console.error('Error fetching unread message count:', error);
      }
    };

    fetchUnreadMessageCount();
  }, [coach.id, coach.token]);

  return (
    <div className={`${isActive("/coach/mysplit") ? "bg-black" : ""}`}>
      <div
        className={`flex flex-row justify-between items-center gap-5 w-full max-w-screen-xl mx-auto pb-2 pt-2 px-5`}
      >
        <Link to="/coach/dashboard" className="w-full max-w-[93px] block">
          {location.pathname === "/coach/mysplit" ? (
            <img
              src={amaxTextWhite}
              alt="amax"
              className="object-contain w-full"
            />
          ) : (
            <img src={amaxText} alt="amax" className="object-contain w-full" />
          )}
        </Link>

        <div className="size-[60px] rounded-full relative cursor-pointer  flex justify-end">
        {coach.photo? (
          <img
            src={API_URL.PROFILE_PICTURE_URL + coach.photo}
            alt="user"
            className="object-cover w-16 rounded-full"
          />
          ):(
            <img
            src={userman}
            alt="user"
            className="object-cover w-12 rounded-full"
          />
          )}
          {  unreadCount>0 && (
             <Link to="/coach/messages">
                  
                    <span className={`${isActive("/athlete/mysplit") ? "!bg-white !text-black" : ""} bg-[#0d0d0d] p-1 min-h-3 min-w-5 text-white text-[10px] font-bold rounded-full flex justify-center items-center absolute top-0 right-0 z-10`}>
                      {unreadCount}
                    </span>
             </Link>
          )
          }
        </div>
      </div>
    </div>
  );
};
